// extracted by css-extract-rspack-plugin
export default {"cls1":"after_click_map-cls1_gP6","cls2":"after_click_map-cls2_Fhm after_click_map-cls1_gP6"};